<a class="root-container" tabindex="0" #content (click)="toggle($event)">
 <div [class]="[ 'button-container', type]">
   <i [class]="['bi',icon]"></i>
 </div>
  @if (badge){
    <div class="badge">
      {{ badge }}
    </div>
  }
  @if (dropdown && show) {
    <div class="dropdown" [ngClass]="{'show': show}" [style.width.rem]="width">
      <div class="header">
        <ng-content select="[slot=header]"></ng-content>
      </div>

      <div class="body">
        <ng-content select="[slot=body]"></ng-content>
      </div>
    </div>
  }
</a>
